// export const API_BASE_URL = 'http://172.20.101.31:8000/api';
export const API_BASE_URL = `${import.meta.env.VITE_APP_API_URL}`;

export const endpoints = {
    alerts: {
        list: '/alerts/',
        detail: (slug) => `/alerts/${slug}/`,
    },
    advisories: {
        list: '/advisories/',
        detail: (slug) => `/advisories/${slug}/`,
    },
    events: {
        list: '/events/',
        detail: (slug) => `/events/${slug}/`,
    },
    news: {
        list: '/news/',
        detail: (slug) => `/news/${slug}/`,
        categories: '/news/categories/',
        incrementView: (slug) => `/news/${slug}/increment-view/`
    },
    resources: {
        list: '/news/resources/',

    },
    cves: {
        list: '/cve/',
        detail: (id) => `/cve/${id}/`,
    },
    faqs: {
        list: '/faqs/',
        detail: (id) => `/faqs/${id}/`,
    },
    contact: {
        submit: '/contact/submit/',
    },
    reports: {
        list: '/reports/',
        byYear: (year) => `/reports/?year=${year}`,
    },
    regulations: {
        list: '/regulations/',
        detail: (id) => `/regulations/${id}/`,
        categories: '/regulations/categories/',
        years: '/regulations/years/',
    },

    cop: {
        list: '/cop/'
    },
    awareness: {
        list: '/threats/',
        detail: (id) => `/threats/${id}/`,
        threatTypes: '/threat-types/'
    },
    hero: {
        list: '/hero-slides/',
    },
    gci: {
        timeline: '/gci/timeline',
        latest: '/gci/latest',
    },
};

// For backward compatibility
export const API_URL = API_BASE_URL;
